import { Modal } from 'antd'
import React, { useEffect, useState } from 'react'
import { getJobs } from '../../services/API/MarketplaceService'
import BottomButton from '../Buttons/BottomButton'
import { PageHeader, Typography, Button, Divider, Drawer } from 'antd';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

function JobDescriptionModal({showJobDescriptionModal, handleCancel, handleOk, clientName, selectedJobDescription}) {
    const [jobData, setJobData] = useState([]);
    const [jobDescription, setJobDescription] = useState({});
    const {t} = useTranslation();

    useEffect(() => {
        getJobs("",`"${clientName}"`)
        .then(response=> {
          setJobData(response.data.viewData.allJobDemands.otherJobDemands);
        })
        .catch(error=> {
          console.log(error);
        });

        setJobDescription(selectedJobDescription);
    }, [clientName])

  return (
    <div className='job-description-drawer'>
      <Drawer
          title={t('job_description')}
          open={showJobDescriptionModal}
          onClose={handleCancel}
          key="jobDescription"
          placement="bottom"
          closable={true}
          height="auto" 
          bodyStyle={{padding:'0px'}}
          footer={[
          <BottomButton buttonText="Back" callBackFunction={handleCancel}/>
        ]}
        >
          <div className="job-details-modal-container">
            {
              jobDescription?.earningDetailsAndBenefits?.length > 0 && <div className="job-type">
                  <Text className="job-detail-title">{t('earning_details_benefits')}</Text>
                  <ul className='job-detail-content'>
                  {
                      jobDescription?.earningDetailsAndBenefits ? 
                      jobDescription.earningDetailsAndBenefits.map(item => {
                          return <li key={item.id}>{item.value}</li>
                      }): null
                  }
                  </ul>
              </div>
            }

            {
              jobDescription?.joiningRequirements?.length > 0 && <div className="salary-range">
                  <Text className="job-detail-title">Joining Requirements</Text>
                  <ul className='job-detail-content'>
                  {
                      jobDescription?.joiningRequirements ? 
                      jobDescription.joiningRequirements.map(item => {
                          return <li key={item.id}>{item.value}</li>
                      }): null
                  }
                  </ul>
              </div>
            }

            {/* {
              jobDescription?.timings?.length > 0 && <div className="job-requirements">
                  <Text className="job-detail-title">Requirements</Text>
                  <ul className='job-detail-content'>
                  {
                      jobDescription?.timings ? 
                      jobDescription.timings.map(item => {
                          return <li key={item.id}>{item.value}</li>
                      }): null
                  }
                  </ul>
              </div>
            } */}

            {
              Object.keys(jobDescription).length === 0 && <Text>{t('no_data')}</Text>
            }
              
          </div>

      </Drawer>
    </div>
  )
}

export default JobDescriptionModal
